export default "__VITE_ASSET__DpAuJHyV__"